import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export default function useGetInvestmentsGrouped() {
  return useQuery({
    queryKey: ["investments/grouped"],
    queryFn: async () => {
      return axiosInstance
        .get("/investments/grouped")
        .then((res) => res.data);
    },
    retry: false,
    staleTime: 1000 * 30,
  });
}
